import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  CircularProgress,
  Alert
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import axiosInstance from '../utils/axiosConfig';




const RideDataDisplay = ({
    bookingId
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log(bookingId)

  useEffect(() => {
    fetchRideData();
  }, []);

  const fetchRideData = async () => {
    const apiEndpoint = `/crm/ride/request-tracking/?ride_id=${bookingId}` 
    try {
      setLoading(true);
      setError(null);
      const response = await axiosInstance.get(apiEndpoint);
      setData(response.data);
    } catch (err) {
      setError(err.message || 'Failed to fetch ride data');
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const statusColors = {
      'REQUEST_SEND': 'info',
      'REQUEST_ACCEPTED': 'success',
      'REQUEST_REJECTED': 'error',
      'REQUEST_AUTOREJECTED': 'warning',
      'RIDE_CANCELLED_BY_RIDER': 'error'
    };
    return statusColors[status] || 'default';
  };

  const formatStatus = (status) => {
    return status.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ width: '100%', p: 2 }}>
        <Alert severity="error" onClose={() => setError(null)}>
          {error}
        </Alert>
      </Box>
    );
  }

  if (!data?.data?.rides || data.data.rides.length === 0) {
    return (
      <Box sx={{ width: '100%', p: 2 }}>
        <Alert severity="info">No ride data available</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      {data.data.rides.map((ride) => (
        <Card key={ride.ride_id} sx={{ mb: 2, boxShadow: 2, borderRadius: 2 }}>
          <CardContent sx={{ p: 2 }}>
            <Typography variant="body1" gutterBottom sx={{ fontWeight: 600, color: 'primary.main', mb: 1.5 }}>
              Ride ID: {ride.ride_id}
            </Typography>
            
            <Divider sx={{ mb: 1.5 }} />
            
            <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 500, color: 'text.secondary' }}>
              Drivers ({ride.drivers.length})
            </Typography>

            {ride.drivers.map((driver) => (
              <Accordion 
                key={driver.driver_id} 
                sx={{ 
                  mb: 1,
                  '&:before': { display: 'none' },
                  boxShadow: 1,
                  borderRadius: '8px !important',
                  overflow: 'hidden'
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
                  sx={{ 
                    backgroundColor: 'grey.50',
                    '&:hover': { backgroundColor: 'grey.100' },
                    py: 1,
                    minHeight: '48px',
                    '&.Mui-expanded': {
                      minHeight: '48px'
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                    <PersonIcon sx={{ color: 'primary.main', fontSize: 22 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {driver.driver_full_name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                        ID: {driver.driver_id}
                      </Typography>
                    </Box>
                  </Box>
                </AccordionSummary>
                
                <AccordionDetails sx={{ p: 1.5 }}>
                  {/* Location Section */}
                  {/* <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                      <LocationOnIcon sx={{ color: 'primary.main', fontSize: 18 }} />
                      <Typography variant="body2" fontWeight="500">
                        Location
                      </Typography>
                    </Box>
                    <Box sx={{ ml: 3.5, p: 1.5, backgroundColor: 'grey.50', borderRadius: 1 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                        Latitude: {driver.driver_location.latitude}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Longitude: {driver.driver_location.longitude}
                      </Typography>
                    </Box>
                  </Box>

                  <Divider sx={{ my: 2 }} /> */}

                  {/* Journey Section */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5 }}>
                    <AccessTimeIcon sx={{ color: 'primary.main', fontSize: 18 }} />
                    <Typography variant="body2" fontWeight="500" sx={{ fontSize: '0.85rem' }}>
                      Ride Requesr Tracking
                    </Typography>
                  </Box>

                  <Stack spacing={1.5} sx={{ ml: 0.5 }}>
                    {driver.ride_journey.map((journey, jIndex) => (
                      <Box 
                        key={jIndex}
                        sx={{ 
                          display: 'flex',
                          gap: 1.5,
                          position: 'relative',
                          '&:not(:last-child)::before': {
                            content: '""',
                            position: 'absolute',
                            left: '9px',
                            top: '20px',
                            bottom: '-12px',
                            width: '2px',
                            backgroundColor: 'grey.300'
                          }
                        }}
                      >
                        <Box 
                          sx={{ 
                            width: 20,
                            height: 20,
                            borderRadius: '50%',
                            backgroundColor: `${getStatusColor(journey.status)}.main`,
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1,
                            boxShadow: 1
                          }}
                        >
                          <Box 
                            sx={{ 
                              width: 6,
                              height: 6,
                              borderRadius: '50%',
                              backgroundColor: 'white'
                            }}
                          />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Chip
                            label={formatStatus(journey.status)}
                            color={getStatusColor(journey.status)}
                            size="small"
                            sx={{ mb: 0.5, fontWeight: 500, height: '22px', fontSize: '0.7rem' }}
                          />
                          <Typography variant="caption" display="block" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                            {formatTimestamp(journey.timestamp)}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Stack>
                </AccordionDetails>
              </Accordion>
            ))}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default RideDataDisplay;